import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'ebb-portal-dialog-switch-dashboard',
    templateUrl: './dialog-switch-dashboard.component.html',
    styles: [],
    standalone: false
})
export class DialogSwitchDashboardComponent implements OnInit {
  public switchForm: FormGroup;
  public _currentUserType: string;

  constructor(
    public dialogRef: MatDialogRef<DialogSwitchDashboardComponent>,
    private readonly fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._currentUserType = data.currentUserType;
   }

  ngOnInit() {
    this.initializeForms();
  }

  private initializeForms(): void {
    // Owner: 700000000; Contractor: 700000001
    this.switchForm = this.fb.group({
      userDashboard: ''
    });

    this.switchForm.get('userDashboard').setValue(this._currentUserType);
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

  public onClickSwitch(): void {
    this.dialogRef.close(this.switchForm.get('userDashboard').value);
  }

}
